export class RmReservedRacksSoRequest {
    saleOrderId:number;
    rmRackId: number;

    constructor(saleOrderId:number,
        rmRackId: number) {
        this.rmRackId = rmRackId;
        this.saleOrderId = saleOrderId;
    }
}